import "./RoundedBoxWithArrow.css";

const RoundedBoxWithArrow = ({ children, label, style = {} }) => {
    const boxBackgroundColor = style.backgroundColor || 'white';

    return (
        <div
            style={{
                display: 'inline-flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <div className="rounded-box-arrow" style={style}>
                {children}
            </div>

            <div
                className="rounded-box-arrow-pointer"
                style={{
                borderTopColor: boxBackgroundColor,
                }}
            />

            {label && (
                <div className="rounded-box-arrow-label">
                    {label}
                </div>
            )}
        </div>
    );
}

export default RoundedBoxWithArrow;